var map = {
	"./BlockWater.jpg": 725,
	"./CalcMahjong.jpg": 726,
	"./CheckCanEat.jpg": 727,
	"./Chow.jpg": 728,
	"./CryingBaby.jpg": 729,
	"./DiceSum.jpg": 730,
	"./DrawTile.jpg": 731,
	"./Eat.jpg": 732,
	"./Gong.jpg": 733,
	"./GuessMahjong.jpg": 734,
	"./Identify.jpg": 735,
	"./MatchEat.jpg": 736,
	"./OtherDroppedTileSort.jpg": 737,
	"./OtherDroppedTiles.jpg": 738,
	"./PairTiles.jpg": 739,
	"./PairTilesAdvanced.jpg": 740,
	"./PayMoney.jpg": 741,
	"./PianoMaster.jpg": 742,
	"./Pong.jpg": 743,
	"./RememberDroppedSequence.jpg": 744,
	"./RememberDroppedTiles.jpg": 745,
	"./SeePicKnowWord.jpg": 746,
	"./ShanghaiMahjong.jpg": 747,
	"./ShuffleTile.jpg": 748,
	"./SortMahJong.jpg": 749,
	"./SpinningWheel.jpg": 750,
	"./StackTileWallShake.jpg": 751,
	"./StopHand.jpg": 752,
	"./SushiTrain.jpg": 753,
	"./TapCharacter.jpg": 754,
	"./TrainMode.jpg": 249,
	"./WashTile.jpg": 755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;